import { useContext } from 'react';

import { maxLength, minLength } from '@app/constants';
import { SendoutsContext } from '@app/providers/SendoutsProvider';

import type { SendoutsFilterFormValues } from '@pages/Sendouts/SendoutsList/types';

import type { BaseOptionType } from 'antd/es/select';

const validationRules = {
  term: [minLength(3), maxLength()],
};

export const useFilterForm = () => {
  const { setSearchTerm } = useContext(SendoutsContext);

  const reset = (onChange: (values: SendoutsFilterFormValues) => void) => {
    if (typeof onChange !== 'function') return;

    onChange({
      SearchTerm: '',
      ChannelIds: [],
      IntegrationIds: [],
      StatusIds: [],
    });

    setSearchTerm('');
  };

  const prepareSubmitValues = (
    values: SendoutsFilterFormValues,
    selectedStatusOptions: BaseOptionType[],
    selectedChannelOptions: BaseOptionType[],
    selectedIntegrationOptions: BaseOptionType[]
  ): SendoutsFilterFormValues => {
    return {
      ...values,
      StatusIds: selectedStatusOptions.map((option) => option.value),
      ChannelIds: selectedChannelOptions.map((option) => option.value),
      IntegrationIds: selectedIntegrationOptions.map((option) => option.value),
    };
  };

  return {
    rules: validationRules,
    reset,
    prepareSubmitValues,
  };
};
